import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    ModalBody,
    ModalCloseBtn,
    ModalContent,
    ModalFooter,
    ModalHeader
} from '@fiverr-private/overlay';
import { I18n } from '@fiverr-private/i18n-react';
import { raiseToast } from '@fiverr-private/toast';
import { Button } from '@fiverr-private/button';
import { turnVacationOff } from '../helper';
import { vacationStatuses } from '../utils/VacationStatus';

const CancelVacationModal = ({ vacationStatus, username, close }) => {
    const [loading, setLoading] = useState(false);

    const onConfirm = async() => {
        try {
            setLoading(true);
            await turnVacationOff(username);
            setLoading(false);

            raiseToast({
                message: <I18n k="out_of_office.go_available_modal.success_toast"/>,
                type: 'success',
                location: 'top'
            });

            close(true);
        } catch (err) {
            setLoading(false);
            raiseToast({
                message: <I18n k="out_of_office.go_available_modal.error_toast"/>,
                type: 'error',
                location: 'top'
            });
        }
    };

    const translationBase = `out_of_office.go_available_modal.${vacationStatus === vacationStatuses.active ? 'active' : 'scheduled'}`;

    return (
        <Modal isOpen={true} onClose={() => close()}>
            <ModalContent size="sm">
                <ModalHeader>
                    <section className="flex flex-justify-between flex-items-center">
                        <I18n k={`${translationBase}.title`}/>
                        <ModalCloseBtn/>
                    </section>
                </ModalHeader>
                <ModalBody>
                    <p>
                        <I18n k={`${translationBase}.text`}/>
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" intent="secondary" onClick={() => close()}>
                        <I18n k="out_of_office.general.cancel"/>
                    </Button>
                    <Button loading={loading} disabled={loading} intent="primary" onClick={onConfirm}>
                        <I18n k={`${translationBase}.cta_button`}/>
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

CancelVacationModal.propTypes = {
    close: PropTypes.func,
    username: PropTypes.string,
    vacationStatus: PropTypes.string
};

export default CancelVacationModal;
